import React, { useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { Switch, Route, useHistory } from "react-router-dom";
import RouteHandler from "./RouteHandler";
import useGlobalStore from "@store/global";
import { SITE_MODE, QUERY_PARAMETER, COOKIES, DATALAYER_EVENTS } from "@constants";
import dataLayerPush from "@assets/js/gtm";
import Cookies from "universal-cookie";

// support languages in the URL prefix
// e.g. /da-DK/path, or /en/path, or /path

export const routePatterns = [
  "/:lang([a-z]{2}-[A-Z]{2})/:sitecoreRoute*",
  "/:lang([a-z]{2})/:sitecoreRoute*",
  "/:sitecoreRoute*",
];

const Container = ({ ssrRenderComplete, setSsrRenderComplete }) => {
  
  const cookies = new Cookies();
  const history = useHistory();
  useEffect(() => {
    history.listen((location) => {
      if (
        useGlobalStore.getState().currentSiteMode === SITE_MODE.PROFESSIONAL
      ) {
        const qp = new URLSearchParams(location.search);
        if (!qp.has(QUERY_PARAMETER.MODE)) {
          qp.set(QUERY_PARAMETER.MODE, SITE_MODE.PROFESSIONAL);
          window.history.replaceState(
            null,
            "Professional persitance",
            `${location.pathname}${
              qp.toString().length ? "?" + qp.toString() : ""
            }`
          );
        }
      }

      // Tracking
      dataLayerPush({ 
        event: DATALAYER_EVENTS.VIRTUALPAGEVIEW, 
        userCountry: useGlobalStore.getState().commerceMarket || 'INT',
        businessType: useGlobalStore.getState().currentSiteMode,
        userId: cookies.get(COOKIES.trackingUserId.name),
        loginStatus: useGlobalStore.getState().userAuthenticated ? "logged in" : ""
      });
      window && window.fbq && window.fbq("track", "PageView");
      window && window.pixie && window.pixie('event', 'PageView');
    });
  }, [history]);

  const routeRenderFunction = (props) => (
    <RouteHandler
      route={props}
      ssrRenderComplete={ssrRenderComplete}
      setSsrRenderComplete={setSsrRenderComplete}
    />
  );

  return (
    <Route
      render={({ location }) => (
        <AnimatePresence
          exitBeforeEnter={true}
          onExitComplete={() => console.log("Container | PAGE EXIT")}
        >
          <Switch location={location} key={location.pathname.split("/")[0]}>
            {routePatterns.map((routePattern) => (
              <Route
                key={routePattern}
                path={routePattern}
                render={routeRenderFunction}
                exact
              />
            ))}
          </Switch>
        </AnimatePresence>
      )}
    />
  );
};
export default Container;
